import {
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

const socials = [
  { icon: <FaWhatsapp />, href: "https://wa.me/819036668177", label: "WhatsApp" },
  { icon: <FaEnvelope />, href: "mailto:ebinbenny055@gmail.com", label: "Gmail" },
  {
    icon: <FaInstagram />,
    href: "https://www.instagram.com/__ebi_____?igsh=MWtsdDNqcDR3eWE5eg==",
    label: "Instagram",
  },
  {
    icon: <FaLinkedinIn />,
    href: "https://www.linkedin.com/in/ebin-benny-18a37b3a5/",
    label: "LinkedIn",
  },
  { icon: <FaGithub />, href: "https://github.com/Zenitsucyberz", label: "GitHub" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-8 px-5">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <a href="#home" className="text-lg font-bold grad-text">
          Ebin Benny
        </a>

        <div className="flex gap-3">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="w-9 h-9 flex items-center justify-center rounded-full glass text-gray-300 hover:text-white hover:bg-gradient-to-r hover:from-violet-500 hover:to-blue-500 transition"
            >
              {s.icon}
            </a>
          ))}
        </div>

        <p className="text-gray-500 text-sm text-center">
          &copy; {new Date().getFullYear()} Ebin Benny. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
